import { request } from './_core'

export interface SupportMessageParams {
  name:      string
  message:   string
  userTier?: string
  expiresAt?: string | null
}

export const support = {
  send: (data: SupportMessageParams) =>
    request<void>('/support', {
      method: 'POST',
      body:   JSON.stringify(data),
    }),
}
